import React, { useState, useEffect } from 'react';
import './LoadingOverlay.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignal, faWifi, faBolt } from '@fortawesome/free-solid-svg-icons';

const LoadingOverlay = ({ isLoading = false }) => {
  const [progress, setProgress] = useState(0);
  const [tips] = useState([
    "Memproses permintaan Anda...",
    "Menghubungkan ke server XL...",
    "Mengambil data kuota...",
    "Hampir selesai...",
    "Harap bersabar..."
  ]);
  const [currentTip, setCurrentTip] = useState(0);

  useEffect(() => {
    if (isLoading) {
      // Animasi progress bar
      const progressInterval = setInterval(() => {
        setProgress(prev => {
          if (prev >= 100) return 0;
          return prev + 2;
        });
      }, 100);

      // Rotate tips
      const tipInterval = setInterval(() => {
        setCurrentTip(prev => (prev + 1) % tips.length);
      }, 3000);

      return () => {
        clearInterval(progressInterval);
        clearInterval(tipInterval);
      };
    } else {
      setProgress(0);
    }
  }, [isLoading, tips.length]);

  if (!isLoading) return null;

  return (
    <div className={`loading-overlay ${isLoading ? 'active' : ''}`}>
      <div className="loading-container">
        {/* Spinner dengan 3 lapisan */}
        <div className="loading-spinner">
          <div className="spinner-circle spinner-circle-1"></div>
          <div className="spinner-circle spinner-circle-2"></div>
          <div className="spinner-circle spinner-circle-3"></div>
          
          {/* Ikon di tengah */}
          <div className="xl-icon">
            <FontAwesomeIcon icon={faSignal} size="2x" color="#4361ee" />
          </div>
        </div>

        {/* Teks utama */}
        <div className="loading-text">
          Sedang mengecek kuota XL & AXIS
          <span className="pulse-dots">
            <span></span>
            <span></span>
            <span></span>
          </span>
        </div>

        {/* Tips bergantian */}
        <div className="loading-subtext">
          <FontAwesomeIcon icon={faBolt} style={{ marginRight: '8px', color: '#4cc9f0' }} />
          {tips[currentTip]}
        </div>

        {/* Progress bar */}
        <div className="progress-container">
          <div 
            className="progress-bar" 
            style={{ width: `${progress}%` }}
          ></div>
        </div>

        {/* Informasi tambahan */}
        <div className="loading-subtext" style={{ marginTop: '20px', fontSize: '12px' }}>
          <FontAwesomeIcon icon={faWifi} style={{ marginRight: '5px' }} />
          Pastikan koneksi internet stabil
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
